import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/profile.css";

const API_BASE = process.env.REACT_APP_API_BASE || 
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" 
    ? "http://localhost:5005/api" 
    : "https://vblogai-backend.onrender.com/api");

export default function Profile() {
  const navigate = useNavigate();
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    phone: "",
    email: "",
    password: ""
  });

  useEffect(() => {
    const userStr = localStorage.getItem("vblog_user");
    if (!userStr) {
      navigate("/signin");
      return;
    }
    const user = JSON.parse(userStr);
    setFormData({
      id: user.id || "",
      name: user.name || "",
      phone: user.phone || "",
      email: user.email || "",
      password: ""
    });
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogout = () => {
    localStorage.removeItem("vblog_user");
    window.dispatchEvent(new Event("authChange"));
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await fetch(`${API_BASE}/auth/profile`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to update profile");
      }

      // Update localStorage
      localStorage.setItem("vblog_user", JSON.stringify(data.user));
      setSuccess("Profile updated successfully!");
      
      // Clear password field
      setFormData(prev => ({ ...prev, password: "" }));
      
      // Fire custom event
      window.dispatchEvent(new Event("authChange"));
    } catch (err) {
      setError(err.message);
    }
  };

  const getInitials = (name) => {
    if (!name) return "U";
    return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
  };

  return (
    <div className="profile-page-wrapper">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">{getInitials(formData.name)}</div>
          <h2>Account Settings</h2>
          <p>Manage and update your public parameters safely</p>
        </div>

        {success && <div className="profile-success">{success}</div>}
        {error && <div className="auth-error">{error}</div>}

        <form className="profile-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <input 
              type="text" 
              name="name" 
              value={formData.name} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input 
              type="tel" 
              name="phone" 
              value={formData.phone} 
              onChange={handleChange} 
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="form-group">
            <label>New Password (leave blank to keep current)</label>
            <input 
              type="password" 
              name="password" 
              placeholder="••••••••" 
              value={formData.password} 
              onChange={handleChange} 
            />
          </div>

          <div className="profile-actions">
            <button type="submit" className="profile-save-btn">
              Save Changes
            </button>
            <button type="button" className="profile-logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
